import VehiclesError from './VehiclesError.js'

export class GetModelDetailContentNotFoundError extends VehiclesError {}
